import {
  StudentDocument,
  StudentDocumentStatus,
} from '../../../core/services/student-portal.service';

export enum DocumentUploadStatus {
  Uploading = 'uploading',
}

export type PreEnrollmentDocument = Omit<StudentDocument, 'status'> & {
  status: StudentDocumentStatus | DocumentUploadStatus;
};
